import React from "react";
import { Link } from "react-router-dom";
import { BRAND } from "@/site.config";
import { Phone, Mail, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#070707] border-t border-white/5 px-5 sm:px-8 pt-20 pb-10"
    >
      <div className="max-w-7xl mx-auto grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3">
            <img
              src={BRAND.logo}
              alt="SIGNA CLEAN"
              className="h-20 w-20 rounded-md ring-1 ring-white/10"
            />
            <div>
              <div className="font-display text-xl font-extrabold">
                <span className="text-[#9DEB30]">SIGNA</span> CLEAN
              </div>
              <div className="text-xs text-zinc-500 font-mono uppercase tracking-[0.2em]">
                {BRAND.tagline}
              </div>
            </div>
          </div>
          <p className="mt-5 text-sm text-zinc-400 max-w-md">
            Nettoyage technique, équipements photoluminescents et signalisation solaire LED.
            Solutions professionnelles en Martinique.
          </p>
        </div>

        <div>
          <div className="text-xs font-mono uppercase tracking-[0.2em] text-zinc-500 mb-4">
            Navigation
          </div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/" className="text-zinc-300 hover:text-[#9DEB30]" data-testid="footer-link-home">Accueil</Link></li>
            <li><Link to="/services" className="text-zinc-300 hover:text-[#9DEB30]" data-testid="footer-link-services">Services</Link></li>
            <li><Link to="/contact" className="text-zinc-300 hover:text-[#9DEB30]" data-testid="footer-link-contact">Contact</Link></li>
            <li><a href={BRAND.clientPortal} className="inline-flex items-center gap-1.5 text-[#9DEB30] hover:text-[#b6f55c]" data-testid="footer-link-client-portal">Espace client</a></li>
            <li><a href={BRAND.teamPortal} className="inline-flex items-center gap-1.5 text-zinc-400 hover:text-white" data-testid="footer-link-team-portal">Accès équipe</a></li>
          </ul>
        </div>

        <div>
          <div className="text-xs font-mono uppercase tracking-[0.2em] text-zinc-500 mb-4">
            Contact
          </div>
          <ul className="space-y-3 text-sm">
            <li>
              <a href={BRAND.phoneHref} className="flex items-center gap-2 text-zinc-300 hover:text-[#9DEB30]">
                <Phone size={14} className="text-[#9DEB30]" /> {BRAND.phone}
              </a>
            </li>
            <li>
              <a href={BRAND.emailHref} className="flex items-center gap-2 text-zinc-300 hover:text-[#9DEB30] break-all">
                <Mail size={14} className="text-[#9DEB30]" /> {BRAND.email}
              </a>
            </li>
            <li className="flex items-start gap-2 text-zinc-400">
              <MapPin size={14} className="text-[#9DEB30] mt-0.5 shrink-0" />
              <span>{BRAND.address.line1}<br/>{BRAND.address.line2}<br/>{BRAND.address.city}</span>
            </li>
            <li className="flex items-center gap-2 text-zinc-500 text-xs font-mono pt-1">
              {BRAND.hours}
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto mt-14 pt-6 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-xs text-zinc-500">
          © {new Date().getFullYear()} SIGNA CLEAN — Tous droits réservés.
        </p>
        <p className="text-[10px] font-mono uppercase tracking-[0.25em] text-zinc-500">
          Sécuriser <span className="text-[#9DEB30]">·</span> Valoriser <span className="text-[#9DEB30]">·</span> Innover
        </p>
      </div>
    </footer>
  );
}
